import { R } from '@/caregiverSpace/resources/Texts.resx';

export const ServerErrorMessage = () => {
    return <p>{R.CannotCompleteOperationMessage}</p>;
};
